import type {AxiosRequestConfig} from 'axios';
import {Province} from './interface';

export class DeleteProvinceBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'DELETE',
    url: '',
  };
  id(id: number) {
    this.provincesRequest.url = `/provinces/${id}`;
    return this;
  }
  build() {
    return this.provincesRequest;
  }
}
export class GetAllProvincesRequestBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/provinces',
    params: {},
  };

  id(id: number) {
    this.provincesRequest.url = `/provinces/${id}`;
    return this;
  }

  params(params: object) {
    this.provincesRequest.params = params;
    return this;
  }

  build() {
    return this.provincesRequest;
  }
}
export class GetProvincesCountRequestBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'GET',
    url: '/provinces/count',
  };

  params(params: object) {
    this.provincesRequest.params = params;
    return this;
  }

  build() {
    return this.provincesRequest;
  }
}

export class CreateProvinceRequestBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'POST',
    url: '/provinces',
    data: {},
  };

  data(data: Province) {
    this.provincesRequest.data = data;
    return this;
  }

  build() {
    return this.provincesRequest;
  }
}

export class UpdateProvinceRequestBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/provinces',
    data: {},
  };
  data(body: Province) {
    this.provincesRequest.data = body;
    return this;
  }
  build() {
    return this.provincesRequest;
  }
}

export class UpdateProvinceStatusRequestBuilder {
  private readonly provincesRequest: AxiosRequestConfig = {
    method: 'PUT',
    url: '/provinces',
    data: {},
  };
  id(id: number) {
    this.provincesRequest.url = `/provinces/${id}/status`;
    return this;
  }
  data(body: Province) {
    this.provincesRequest.data = body;
    return this;
  }
  build() {
    return this.provincesRequest;
  }
}
